import type { Hit as AlgoliaHit } from 'instantsearch.js';

import { useConfigContext } from '../ConfigProvider';
import type {AlgoliaProductAttributes} from "../AlgoliaProductAttributes";

const STATIC_FACET_ATTRIBUTES: string[] = [
    'attributes.Produzent',
    'attributes.Jahrgang',
    'attributes.Ursprungsland'
];

function processHitAttributes(hit: AlgoliaHit<AlgoliaProductAttributes>, refinementList: any[], attributesToRender: string[]): string[] {
    if (!refinementList || !attributesToRender) return [];

    return refinementList
        .filter(item => attributesToRender.includes(item.name))
        .flatMap(item => {
            const value = hit[item.name as keyof typeof hit];
            if (Array.isArray(value)) {
                return value
                    .filter((val) =>
                        (typeof val === 'string' && val.trim() !== '') ||
                        (typeof val === 'number' && val !== 0)
                    )
                    .map(val => String(val));
            }
            return [];
        });
}


export function useHitAttributes(hit: AlgoliaHit<AlgoliaProductAttributes>): string[] {
    const { algoliaRefinements: { refinementList } } = useConfigContext();

    return processHitAttributes(hit, refinementList, STATIC_FACET_ATTRIBUTES);
}

export function useHitAttributesAutocomplete(hit: AlgoliaHit<AlgoliaProductAttributes>): string[] {
    const { algoliaRefinements: { refinementList } } = useConfigContext();

    return processHitAttributes(hit, refinementList, STATIC_FACET_ATTRIBUTES);
}